/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * User update data
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * User's full name
     * @type {string}
     * @memberof UpdateUserRequest
     */
    name?: string;
    /**
     * User's given name
     * @type {string}
     * @memberof UpdateUserRequest
     */
    givenName?: string;
    /**
     * User's family name
     * @type {string}
     * @memberof UpdateUserRequest
     */
    familyName?: string;
    /**
     * User's profile picture URL
     * @type {string}
     * @memberof UpdateUserRequest
     */
    picture?: string;
    /**
     * User's preferred username
     * @type {string}
     * @memberof UpdateUserRequest
     */
    preferredUsername?: string;
    /**
     * User's preferred timezone
     * @type {string}
     * @memberof UpdateUserRequest
     */
    preferredTimezone?: string;
    /**
     * Whether the user account should be active
     * @type {boolean}
     * @memberof UpdateUserRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateUserRequest interface.
 */
export function instanceOfUpdateUserRequest(value: object): value is UpdateUserRequest {
    return true;
}

export function UpdateUserRequestFromJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestFromJSONTyped(json, false);
}

export function UpdateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'givenName': json['givenName'] == null ? undefined : json['givenName'],
        'familyName': json['familyName'] == null ? undefined : json['familyName'],
        'picture': json['picture'] == null ? undefined : json['picture'],
        'preferredUsername': json['preferredUsername'] == null ? undefined : json['preferredUsername'],
        'preferredTimezone': json['preferredTimezone'] == null ? undefined : json['preferredTimezone'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateUserRequestToJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestToJSONTyped(json, false);
}

export function UpdateUserRequestToJSONTyped(value?: UpdateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'givenName': value['givenName'],
        'familyName': value['familyName'],
        'picture': value['picture'],
        'preferredUsername': value['preferredUsername'],
        'preferredTimezone': value['preferredTimezone'],
        'isActive': value['isActive'],
    };
}

